import { React } from 'react';
import { Flex, Box, Text, Divider, Radio, RadioGroup, Stack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { Controller, useFormContext } from 'react-hook-form';
import StyledAccordionItem from './StyledAccordionItem';
import GreenTitleBox from './GreenTitleBox';
import TextAreaBox from './TextAreaBox';
import { metadataOptions, selectStyles } from '../../helpers/chakraSelect';

function RecommendationAccordion({ interview, metadata }) {
  const methods = useFormContext();

  return (
    <StyledAccordionItem title='Recommendation Summary'>
      <Flex flexDirection='column'>
        <Flex alignItems='center' my='4px'>
          <Box mb='-24px'>
            <GreenTitleBox
              title="1. Candidate's Status:"
              helpText='Choose an option based on your general appreciation of the candidate for this or any other opportunity in Nexton. Considering all 3 dimensions (technical skills, soft skills and English level) Could they be presented to a client?'
            />
          </Box>
          <Controller
            name='Nexton_Status'
            control={methods.control}
            render={({ field: { onChange, value } }) => (
              <RadioGroup size='lg' onChange={onChange} value={value} marginLeft='24px'>
                <Stack direction='row'>
                  <Radio value='CORE' mr='24px'>
                    <Text fontSize='14px'>RECOMMEND this candidate (CORE)</Text>
                  </Radio>
                  <Radio value='Not Core'>
                    <Text fontSize='14px'>DO NOT RECOMMEND this candidate (NOT CORE)</Text>
                  </Radio>
                </Stack>
              </RadioGroup>
            )}
          />
        </Flex>

        <Divider my='24px' />

        <Box mb='4px'>
          <GreenTitleBox
            title='2. General Score:'
            helpText="Choose a qualification from the list below taking into account the candidate's general fit for jobs, not only for this specific opportunity."
          />
          <Controller
            name='General_Score2'
            control={methods.control}
            render={({ field: { onChange, value } }) => (
              <RadioGroup size='lg' onChange={onChange} value={value}>
                <Stack spacing={4}>
                  {metadata
                    ?.find(i => i.api_name === 'General_Score2')
                    ?.pick_list_values?.filter(j => !j.display_value.includes('None'))
                    .map(k => (
                      <Radio value={k.display_value} key={k.display_value} mr='24px'>
                        <Text fontSize='14px'>{k.display_value}</Text>
                      </Radio>
                    ))}
                </Stack>
              </RadioGroup>
            )}
          />
          <RadioGroup
            size='lg'
            value={interview.interviewData.General_Score2?.slice(0, 1)}
            {...methods.register('test')}
          />
        </Box>

        <Divider my='24px' />

        <GreenTitleBox
          title='3. Position and Seniority recommendation:'
          helpText="Choose one or more position and seniority recommendations based on your assessment of candidate's skills."
        />

        <Flex gap='12' mb='8px'>
          <Flex flex='2' alignItems='center'>
            <Text mr='16px'>Position:</Text>
            <Box width='100%'>
              <Controller
                name='Main_role'
                control={methods.control}
                render={({ field: { onChange, value } }) => {
                  const handleSelectChange = selectedOption => {
                    onChange(selectedOption?.map(item => item.value));
                  };
                  const curatedValue = value || [];
                  return (
                    <Select
                      isMulti
                      name='position'
                      options={metadataOptions(metadata, 'Main_role')}
                      selectedOptionStyle='check'
                      closeMenuOnSelect={false}
                      chakraStyles={selectStyles}
                      onChange={handleSelectChange}
                      value={curatedValue?.map(item => ({ value: item, label: item }))}
                    />
                  );
                }}
              />
            </Box>
          </Flex>
          <Flex flex='2' alignItems='center' flexGrow='grow'>
            <Text mr='16px'>Seniority:</Text>
            <Box width='100%'>
              <Controller
                name='Recommended_Seniority'
                control={methods.control}
                render={({ field: { onChange, value } }) => {
                  const handleSelectChange = selectedOption => {
                    onChange(selectedOption?.map(item => item.value));
                  };

                  const curatedValue = value || [];

                  return (
                    <Select
                      isMulti
                      name='seniority'
                      options={metadataOptions(metadata, 'Recommended_Seniority')}
                      selectedOptionStyle='check'
                      closeMenuOnSelect={false}
                      chakraStyles={selectStyles}
                      value={curatedValue?.map(item => ({ value: item, label: item }))}
                      onChange={handleSelectChange}
                    />
                  );
                }}
              />
            </Box>
          </Flex>
        </Flex>

        <Divider my='24px' />

        <GreenTitleBox
          title='4. Job Opening Specific Score:'
          helpText="Considering the particular opportunity that was sent to you, select a qualification from the list below taking into account the candidate's fit for it."
        />

        <Flex gap='12' mb='8px'>
          <Flex flexDirection='column' flex='3'>
            <Box>
              <Controller
                name='General_Score'
                control={methods.control}
                render={({ field: { onChange, value } }) => (
                  <RadioGroup size='lg' onChange={onChange} value={value}>
                    <Stack spacing={4}>
                      {metadata
                        ?.find(item => item.api_name === 'General_Score')
                        ?.pick_list_values?.filter(item => !item.display_value.includes('None'))
                        .map(item => (
                          <Radio value={item.display_value} key={item.display_value} mr='24px'>
                            <Text fontSize='14px'>{item.display_value}</Text>
                          </Radio>
                        ))}
                    </Stack>
                  </RadioGroup>
                )}
              />
            </Box>
          </Flex>

          <Flex flexDirection='column' flex='4'>
            <Controller
              name='Job_Opening_Specific_Score_Notes'
              control={methods.control}
              render={({ field: { onChange, value } }) => (
                <TextAreaBox
                  title='Comments:'
                  helpText="Provide a summary explaining the candidate's status you chose, the general score assigned and why you think this candidate is a good fit / or not. Mention strengths and aspects to improve. The more insights you provide the better."
                  onChange={onChange}
                  value={value}
                  height='144px'
                />
              )}
            />
          </Flex>
        </Flex>
      </Flex>
    </StyledAccordionItem>
  );
}

export default RecommendationAccordion;
